module.exports = __webpack_public_path__ + "img/dgitem10.997d896e.png";